import { useContext } from 'react';

import { useQuery } from 'react-query';

import { verifyInUseEquipmentStatus } from '@services/queries/equipmentStatus';
import { indexStudioEquipmentStatus } from '@services/queries/studios';

import { NavigationContext } from '@layout/navigation/navigation';
import { showDefaultStatus } from '@services/queries/studios/showDefaultStatus/showDefaultStatus';
import { DeleteEquipmentStatusRaw } from './DeleteEquipmentStatus.raw';
import { CustomStatusContext } from '../../CustomStatus.query';

import { DeleteEquipmentStatusLoading } from './DeleteEquipmentStatus.loading';
import { DeleteEquipmentStatusError } from './DeleteEquipmentStatus.error';

export const DeleteEquipmentStatusQuery = () => {
  const { openDelete, equipmentStatus } = useContext(CustomStatusContext);

  const { studioId } = useContext(NavigationContext);

  const verifyQuery = useQuery(
    ['equipmentStatus', equipmentStatus.id, 'inUse'],
    () => verifyInUseEquipmentStatus(equipmentStatus.id),
  );

  const defaultStatus = useQuery(['defaultStatus', studioId], () =>
    showDefaultStatus({ id: studioId }),
  );

  const equipmentStatusesQuery = useQuery(
    ['studios', studioId, 'customStatus'],
    () =>
      indexStudioEquipmentStatus({
        id: studioId,
        search: '',
      }),
  );

  if (
    verifyQuery.isLoading ||
    equipmentStatusesQuery.isLoading ||
    defaultStatus.isLoading
  ) {
    return <DeleteEquipmentStatusLoading />;
  }

  if (
    verifyQuery.isError ||
    equipmentStatusesQuery.isError ||
    defaultStatus.isError
  ) {
    return <DeleteEquipmentStatusError />;
  }

  if (!verifyQuery.data || !equipmentStatusesQuery.data) {
    return <DeleteEquipmentStatusError />;
  }

  return (
    <DeleteEquipmentStatusRaw
      open={openDelete}
      equipmentStatus={equipmentStatus}
      verifyStatus={verifyQuery.data}
      equipmentStatuses={equipmentStatusesQuery.data}
      defaultStatus={defaultStatus.data}
    />
  );
};
